import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';

const style = require('./RequestsForProposalPage.css');

export default class RequestsForProposalPage extends React.Component<any, null> {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				<Route
					path="/buyer/requestsForProposal"
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: '/buyer/requestsForProposal/overview',
							}}
						/>
					)}
				/>
				{this.props.childRoutes.map((r, i) => (
					<RouteWithSubRoutes key={i} {...r} />
				))}
			</div>
		);
	}
}
